export const GET_SETTINGS_FAILURE = 'GET_SETTINGS_FAILURE';

export const getSettingsFailure = ( payload: Error ) => ({
    type: GET_SETTINGS_FAILURE,
    payload,
});